import React from 'react';
import "./style.less";

export default function ProgramPage() {
	return <div className="programPage">
		<h2 className="programPage__place">PROGRAM SOBOTA 28. 5.</h2>
		<ul className="programPage__list">
			<li className="programPage__listItem">dopoledne příjezd hostů, ubytování</li>
			<li className="programPage__listItem"><strong>13:00</strong> obřad</li>
			<li className="programPage__listItem"><strong>14:00</strong> oběd</li>
			<li className="programPage__listItem"><strong>15:30</strong> krájení dortu</li>
			<li className="programPage__listItem"><strong>15:45</strong> svatební focení</li>
			<li className="programPage__listItem"><strong>16:50</strong> házení kytice a podvazku</li>
			<li className="programPage__listItem"><strong>17:00</strong> degustace</li>
			<li className="programPage__listItem"><strong>18:15</strong> první tanec</li>
			<li className="programPage__listItem"><strong>18:30</strong> začátek rautu</li>
			<li className="programPage__listItem"><strong>20:00</strong> svatební kvíz</li>
		</ul>
		<h2 className="programPage__place">PROGRAM NEDĚLE 29. 5.</h2>
		<ul className="programPage__list">
			<li className="programPage__listItem"><strong>8:00 - 10:00</strong> snídaně</li>
			<li className="programPage__listItem"><strong>10:30</strong> odjezd</li>
		</ul>
		<h2 className="programPage__place">MENU</h2>
		<ul className="programPage__list">
			<li className="programPage__listItem"><strong>přípitek</strong> - frizzante</li>
			<li className="programPage__listItem"><strong>předkrm</strong> - domácí paštika ve slanině</li>
			<li className="programPage__listItem"><strong>polévka</strong> - hovězí vývar s játrovými knedlíčky</li>
			<li className="programPage__listItem"><strong>hlavní chod</strong> - vepřová panenka se švestkami, opékaný brambor</li>
		</ul>
	</div>;
}
